import React, { useState } from 'react';
import SkillBadge from '../../../common/skillBadge';
import { formatPostedOnDate } from '../../../common/helpers';
import { useNavigate } from 'react-router-dom';

const OtherJobsSidebar = ({ jobs, currentJobId, onJobClick }) => {
  const navigate = useNavigate();
  const handleViewJobClick = () => {
    navigate(`/jobs`);
  };  
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 h-[calc(100vh-9rem)] max-h-[calc(100vh-9rem)]" >
      <div className="lg:col-span-1">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xs font-semibold mph-primary mt-5">Other jobs</h2>
          {(Array.isArray(jobs) && jobs.length > 0 && !(jobs.length === 1 && jobs[0].id === currentJobId)) && (
            <button
              type="button"
              className="text-xs text-gray-500 hover:text-gray-700 mt-5"
              onClick={handleViewJobClick}
            >
              View all
            </button>
          )}
        </div>

        <div className="space-y-4 max-h-[calc(100vh-15rem)] overflow-y-auto">
          {!jobs ? (
            <div className="text-gray-333 text-xs italic">No job list found.</div>
          ) : jobs.length === 0 ? (
            <div className="text-gray-333 text-xs italic">No other jobs available.</div>
          ) : jobs.length === 1 && jobs[0].id === currentJobId ? (
            <div className="text-gray-333 text-xs">No other jobs available.</div>
          ) : (
            jobs
              .filter(job => job.mph_jobid !== currentJobId)
              .map((job, index) => (
                <JobCard
                  key={index}
                  job={job}
                  onJobClick={onJobClick}
                  role="button"
                  tabIndex={0}
                  onKeyPress={e => ['Enter', ' '].includes(e.key) && onJobClick(job)}
                  className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 cursor-pointer hover:bg-gray-50 transition"
                />
              ))
          )}
        </div>
      </div>
    </div>
  );
};

const JobCard = ({ job, onJobClick }) => {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const skills = job.skills_required || [];
  const visibleSkills = showAllSkills ? skills : skills.slice(0, 3);
  const hiddenCount = skills.length - 3;

  return (
    <div
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-5 cursor-pointer hover:bg-gray-50 transition"
      onClick={() => onJobClick(job)}
      role="button"
      tabIndex={0}
      onKeyPress={e => ['Enter', ' '].includes(e.key) && onJobClick(job)}
    >
      <h3 className="text-lg font-semibold mb-1">
        <SkillBadge size="lg">{job.title}</SkillBadge>
      </h3>
      <p className="text-sm text-gray-666 mb-4">
        {job.company_name} – {job.location || job.city}
      </p>

      <div className="space-y-2 text-sm border-t border-gray-100 pt-4">
        {[
          { label: "Job ID", value: job.mph_jobid },
          { label: "Posted on", value: formatPostedOnDate(job.posted_date) },
          { label: "Location", value: job.location || job.city },
          {
            label: "Experience required",
            value: (job.experience_min || job.experience_max)
              ? `${job.experience_min ? job.experience_min : ''}${job.experience_max ? `-${job.experience_max}` : ''}`
              : '-'
          },
          { label: "Vacancies", value: job.vacancies || job.vacancy },
          { label: "Application Deadline", value: formatPostedOnDate(job.application_deadline_datetime) }
        ].map(({ label, value }) => (
          <div key={label} className="grid grid-cols-[150px_1fr] gap-2 text-xs">
            <span className="text-gray-666">{label}</span>
            <span className="font-medium">{value}</span>
          </div>
        ))}
        {/* <div className="grid gap-2">
          <span className="text-gray-666 text-xs">Skills & Expertise required</span>
          <div className="flex flex-wrap gap-2 items-center">
            {visibleSkills.map((skill, idx) => (
              <SkillBadge key={`${skill}-${idx}`}>{skill}</SkillBadge>
            ))}

            {hiddenCount > 0 && !showAllSkills && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAllSkills(true);
                }}
                className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
              >
                +{hiddenCount} more
              </button>
            )}

            {showAllSkills && hiddenCount > 0 && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAllSkills(false);
                }}
                className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
              >
                Show less
              </button>
            )}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default OtherJobsSidebar;